import moment from 'moment'
import numeral from 'numeral'

export const flattenAddress = address => {
  const fields = ['line1', 'line2', 'city', 'county', 'postcode']
  return fields
    .filter(f => address[f])
    .map(f => address[f])
    .join(', ')
}

const numberFormatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  maximumFractionDigits: 4,
})

export const formatPrice = price => numberFormatter.format(price)

export const formatDate = date => moment(date).format('DD/MM/YYYY')
export const formatDateHyphens = date =>
  date ? moment(date).format('YYYY-MM-DD') : null
export const formatDateTime = date => moment(date).format('DD/MM/YYYY HH:mm')
export const formatDateSearch = date => moment(date).format('YYYY/MM/DD HH:mm')

export const generateOrderNumber = order => {
  const { buyerId, environmentId, id, supplierId } = order
  const parts = [supplierId, buyerId, environmentId, id]
  return parts.map(p => numeral(p).format('00')).join('-')
}
